import SpeakerCard from "../Card/SpeakerCard";
import speakers from "../../data/speakers";

const SpeakerComponent = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-bold text-center mb-16 text-indigo-800">Speakers and Bios</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 sm:gap-12 mt-4">
                {speakers.map((speaker, index) => (
                    <SpeakerCard key={index} speaker={speaker} />
                ))}
            </div>
        </div>
    );
};

export default SpeakerComponent;
